//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'SubscribeBanner2026',
  data() {
    return {
      faBolt,
      subscriptionTextCount: renderContentCount(this, publishedContentCounts.total.subscription.element, 1, true),
    };
  },
  computed: {
    ...mapGetters({
      monthlyPrice: 'subscription/getPlanPriceMonthlyString',
    }),
  },
};
